export default __webpack_public_path__ + "music-note-black-symbol.png";